<template>
  <select v-model="budget">
    <option v-for="(budget,index) in budgets" :key="index" :value="budget">{{budget.title}}</option>
  </select>
</template>

<script>
export default {
  name: "budget2",
  props: {
    value: {
      type: [String, Number]
    }
  },
  data() {
    return {
      budgets: [],
      budget: null
    };
  },
  created() {
    let self = this;
    axios({
      method: "get",
      url: "/api/v1/budget/all"
    })
      .then(function(response) {
        if (response.data.ok) {
          self.budgets = response.data.data;
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  },
  watch: {
    budget: {
      immediate: true,
      handler() {
        if (this.budget != null && this.budget != undefined) {
          this.$emit("input", this.budget.id);
        }
      }
    },
    value: {
      immediate: true,
      handler() {
        if (
          this.budget == null &&
          this.value != null &&
          this.value != undefined &&
          this.value != ""
        ) {
          let self = this;

          axios({
            method: "get",
            url: "/api/v1/budget/" + self.value + "/show"
          })
            .then(function(response) {
              if (response.data.ok) {
                self.budget = response.data.data;
              }
            })
            .catch(function(err) {
              console.log(err);
            });
		}
		if(this.value == ''){
			this.budget = null
		}
      }
    }
  }
};
</script>
